import { FC, useState, useEffect } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, SxProps, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { useSearch, SEARCH_PARAM_START_DATE } from '@carcareers/contexts';

interface JobSearchStartDateInputProps {
  sx?: SxProps;
}

export const JobSearchStartDateInput: FC<JobSearchStartDateInputProps> = ({ sx }) => {
  const { startDate: startDateContext, updateSearchParams } = useSearch();
  const [startDate, setStartDate] = useState<Dayjs | null>(
    startDateContext ? dayjs(startDateContext) : null
  );

  const handleDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
    if (newValue) {
      updateSearchParams(SEARCH_PARAM_START_DATE, newValue.format('YYYY-MM-DD'));
    } else {
      updateSearchParams(SEARCH_PARAM_START_DATE, undefined);
    }
  };

  useEffect(() => {
    if (startDateContext) {
      const dateFromContext = dayjs(startDateContext);
      if (!startDate || !dateFromContext.isSame(startDate, 'day')) {
        setStartDate(dateFromContext);
      }
    } else if (startDate !== null) {
      setStartDate(null);
    }
  }, [startDateContext]);

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Typography variant="h6" gutterBottom>Start Date</Typography>
      <DatePicker
        value={startDate}
        onChange={handleDateChange}
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
            placeholder: "MM/DD/YYYY",
          },
        }}
        format="MM/DD/YYYY"
        disablePast={false}
        className="date-picker"
        sx={{
          width: '100%',
          '& .MuiInputBase-root': {
            borderRadius: 1,
          },
        }}
      />
    </Box>
  );
};

export default JobSearchStartDateInput;
